import { Button } from '@/components/shadcn/button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconV2ArchiveOutline } from '@icons/IconV2ArchiveOutline'
import { useState } from 'react'
import { toast } from 'sonner'
import { useCurrentOrganisation } from '../../useCurrentOrganisation'

type ArchiveWorkspaceConfirmDialogProps = {
  workspaceId: number
}

export function ArchiveWorkspaceConfirmDialog({ workspaceId }: ArchiveWorkspaceConfirmDialogProps) {
  const [isOpen, setIsOpen] = useState(false)
  const { id: orgId } = useCurrentOrganisation()

  const {
    postSubscriptionsApiArchiveOrganisationWorkspace,
    getSubscriptionsApiGetOrganisationWorkspacesSummary,
    getWorkspacesApiGetCurrentUserWorkspaces,
    getWorkspacesApiGetCurrentUserWorkspace,
  } = useRestClient()
  const { mutate: archiveWorkspace, isPending } = postSubscriptionsApiArchiveOrganisationWorkspace.useMutation()

  const handleArchive = () => {
    archiveWorkspace(
      {
        query: { workspaceId },
      },
      {
        onSuccess: () => {
          toast.success('Workspace archived successfully')
          setIsOpen(false)
          getSubscriptionsApiGetOrganisationWorkspacesSummary.invalidateQueries({
            parameters: { query: { orgId } },
          })
          getWorkspacesApiGetCurrentUserWorkspaces.invalidateQueries()
          getWorkspacesApiGetCurrentUserWorkspace.invalidateQueries({
            parameters: { path: { workspaceId } },
          })
        },
        onError: () => {
          toast.error('Error archiving workspace')
        },
      }
    )
  }

  return (
    <ConfirmDialog
      trigger={
        <Button size="icon" variant="ghost" aria-label="Archive workspace">
          <IconV2ArchiveOutline className="size-5" />
        </Button>
      }
      triggerTooltip="Archive workspace"
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      title="Archive workspace"
      description="Are you sure you want to archive this workspace?"
      confirmLabel="Archive"
      confirmVariant="destructive"
      onConfirm={handleArchive}
      closeOnConfirm={false}
      isSubmitting={isPending}
    />
  )
}
